import { render, staticRenderFns } from "./AnimatedWave.vue?vue&type=template&id=68c76e11&scoped=true"
import script from "./AnimatedWave.vue?vue&type=script&lang=js"
export * from "./AnimatedWave.vue?vue&type=script&lang=js"
import style0 from "./AnimatedWave.vue?vue&type=style&index=0&id=68c76e11&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c76e11",
  null
  
)

export default component.exports